import { Component, OnInit } from '@angular/core';
import { AbstractEditorComponent } from '../abstract-editor.component';
import { SelectItem } from '@tj/tj-dmp-lib-api';
import { TranslateService } from '@ngx-translate/core';
import { AbstractControl, FormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ValidatorEditorService } from '../validator-editor.service';

export function typeAndDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const typeValue = control.get('type')?.value;
    const dateValue = control.get('date')?.value;

    const isTypeEmpty = !typeValue || typeValue === '';
    const isDateEmpty = !dateValue || dateValue === '';

    // Si un champ est rempli, l'autre doit l'être aussi
    if (isTypeEmpty && !isDateEmpty) {
      return { incompleteType: true };
    }

    if (!isTypeEmpty && isDateEmpty) {
      return { incompleteDate: true };
    }

    return null;
  }
}

@Component({
    selector: 'dmp-current-type-editor',
    templateUrl: './current-type-editor.component.html',
    styleUrls: ['../editor.component.scss'],
    standalone: false
})
export class CurrentTypeEditorComponent extends AbstractEditorComponent implements OnInit {

  items: SelectItem[] = [];
  screenIsLoaded = false;
  newData: boolean = false;

  constructor(protected translate: TranslateService,
    protected fb: FormBuilder,
    protected validatorService: ValidatorEditorService) {
    super(fb, validatorService);
  }

  transformBeforeSave(value: any) {
    return value;
  }

  ngOnInit(): void {
    this.init();
    this.newData = (this.originalValue == null || this.originalValue.trim() === '') && !this.importMode;
    this.updateCmp();
  }

  private updateCmp() {
    if (this.newData) {
      this.formGroup.addControl('new', this.fb.group({
        type: ['', []],
        date: ['', []]
      }, { validators: typeAndDateValidator() }));
    }
    
    this.items = [{
      label: this.translate.instant('common.CUSTOMER'),
      value: 'customer'
    }, {
      label: this.translate.instant('common.PROSPECT'),
      value: 'prospect'
    }, {
      label: this.translate.instant('common.SUSPECT'),
      value: 'suspect'
    }];
    this.screenIsLoaded = true;
  }

    /**
     * Met à jour la valeur principale quand le type change
     */
    updateType(event) {
        this.updateMainValue();
    }

    /**
     * Met à jour la valeur principale quand la date change
     */
    updateDate(event) {
        this.updateMainValue();
    }

    /**
     * Construit la valeur finale à partir des deux champs
     */
    private updateMainValue() {
        const typeValue = this.formGroup.get('new.type')?.value;
        const dateValue = this.formGroup.get('new.date')?.value;

        let newValue: string;

        if (typeValue && dateValue) {
            const formattedDate = this.formatDate(dateValue);
            newValue = `${typeValue}|${formattedDate}`;
            this.formGroup.get('value').setValue(newValue);
        } else {
            newValue = '';
            this.formGroup.get('value').setValue(newValue, { emitEvent: false });
        }
    }

    /**
     * Formate la date au format souhaité
     */
    private formatDate(date: Date): string {
        if (!date) return '';
        
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        
        return `${year}-${month}-${day}`;
    }

}
